import { Injectable } from '@angular/core';
import { UserSessionSettings } from '../interfaces/user-session-settings';

@Injectable({
  providedIn: 'root'
})
export class UserSessionSettingsProvider {

  private userSessionSettings: UserSessionSettings = {};

  set(key: string, value: any) {
    this.userSessionSettings[key] = value;
  }

  get(key:string): any {
    return this.userSessionSettings[key];
  }

  hasValue(key:string): boolean {
    return !(this.userSessionSettings[key] === undefined);
  }

  reset(): void {
    this.userSessionSettings = {};
  }

}
